const ListItemContexts = {
  item: 'item',
  dropdownItem: 'dropdown-item',
};

export default ListItemContexts;
